/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { Brand } from './Brand';
import {
    BrandFromJSON,
    BrandFromJSONTyped,
    BrandToJSON,
} from './Brand';
import type { CalibrationDataDtoCalibrationState } from './CalibrationDataDtoCalibrationState';
import {
    CalibrationDataDtoCalibrationStateFromJSON,
    CalibrationDataDtoCalibrationStateFromJSONTyped,
    CalibrationDataDtoCalibrationStateToJSON,
} from './CalibrationDataDtoCalibrationState';
import type { CoordinateSystem } from './CoordinateSystem';
import {
    CoordinateSystemFromJSON,
    CoordinateSystemFromJSONTyped,
    CoordinateSystemToJSON,
} from './CoordinateSystem';
import type { DeviceInterfaceType } from './DeviceInterfaceType';
import {
    DeviceInterfaceTypeFromJSON,
    DeviceInterfaceTypeFromJSONTyped,
    DeviceInterfaceTypeToJSON,
} from './DeviceInterfaceType';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { IotDeviceStateOfUse } from './IotDeviceStateOfUse';
import {
    IotDeviceStateOfUseFromJSON,
    IotDeviceStateOfUseFromJSONTyped,
    IotDeviceStateOfUseToJSON,
} from './IotDeviceStateOfUse';
import type { PossibleActionDto } from './PossibleActionDto';
import {
    PossibleActionDtoFromJSON,
    PossibleActionDtoFromJSONTyped,
    PossibleActionDtoToJSON,
} from './PossibleActionDto';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';
import type { PtwRegistrationState } from './PtwRegistrationState';
import {
    PtwRegistrationStateFromJSON,
    PtwRegistrationStateFromJSONTyped,
    PtwRegistrationStateToJSON,
} from './PtwRegistrationState';
import type { QaEquipmentStateOfUse } from './QaEquipmentStateOfUse';
import {
    QaEquipmentStateOfUseFromJSON,
    QaEquipmentStateOfUseFromJSONTyped,
    QaEquipmentStateOfUseToJSON,
} from './QaEquipmentStateOfUse';
import type { QaEquipmentSubCategory } from './QaEquipmentSubCategory';
import {
    QaEquipmentSubCategoryFromJSON,
    QaEquipmentSubCategoryFromJSONTyped,
    QaEquipmentSubCategoryToJSON,
} from './QaEquipmentSubCategory';
import type { ReferencingObjectDto } from './ReferencingObjectDto';
import {
    ReferencingObjectDtoFromJSON,
    ReferencingObjectDtoFromJSONTyped,
    ReferencingObjectDtoToJSON,
} from './ReferencingObjectDto';
import type { RtSystemCategory } from './RtSystemCategory';
import {
    RtSystemCategoryFromJSON,
    RtSystemCategoryFromJSONTyped,
    RtSystemCategoryToJSON,
} from './RtSystemCategory';
import type { RtSystemManufacturer } from './RtSystemManufacturer';
import {
    RtSystemManufacturerFromJSON,
    RtSystemManufacturerFromJSONTyped,
    RtSystemManufacturerToJSON,
} from './RtSystemManufacturer';
import type { SingleDetectorConnectorType } from './SingleDetectorConnectorType';
import {
    SingleDetectorConnectorTypeFromJSON,
    SingleDetectorConnectorTypeFromJSONTyped,
    SingleDetectorConnectorTypeToJSON,
} from './SingleDetectorConnectorType';
import type { UserCatalogDto } from './UserCatalogDto';
import {
    UserCatalogDtoFromJSON,
    UserCatalogDtoFromJSONTyped,
    UserCatalogDtoToJSON,
} from './UserCatalogDto';
import type { WithSerialNumber } from './WithSerialNumber';
import {
    WithSerialNumberFromJSON,
    WithSerialNumberFromJSONTyped,
    WithSerialNumberToJSON,
} from './WithSerialNumber';

/**
 * 
 * @export
 * @interface UnicheckSimulatorDto
 */
export interface UnicheckSimulatorDto {
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof UnicheckSimulatorDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UnicheckSimulatorDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UnicheckSimulatorDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UnicheckSimulatorDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UnicheckSimulatorDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof UnicheckSimulatorDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {Array<PossibleActionDto>}
     * @memberof UnicheckSimulatorDto
     */
    readonly possibleActions?: Array<PossibleActionDto> | null;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof UnicheckSimulatorDto
     */
    creatorUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof UnicheckSimulatorDto
     */
    lastModifierUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof UnicheckSimulatorDto
     */
    editingUser?: UserCatalogDto;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    editingTime?: string | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof UnicheckSimulatorDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof UnicheckSimulatorDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof UnicheckSimulatorDto
     */
    isReferenced?: boolean;
    /**
     * 
     * @type {Array<ReferencingObjectDto>}
     * @memberof UnicheckSimulatorDto
     */
    isReferencedBy?: Array<ReferencingObjectDto> | null;
    /**
     * 
     * @type {number}
     * @memberof UnicheckSimulatorDto
     */
    readonly deleterUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    readonly deletionTime?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UnicheckSimulatorDto
     */
    readonly isDeleted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    typeSpecification?: string | null;
    /**
     * 
     * @type {RtSystemCategory}
     * @memberof UnicheckSimulatorDto
     */
    category: RtSystemCategory;
    /**
     * 
     * @type {RtSystemManufacturer}
     * @memberof UnicheckSimulatorDto
     */
    manufacturer: RtSystemManufacturer;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    subModel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    imageId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UnicheckSimulatorDto
     */
    isArchived?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    masterDeviceId?: string | null;
    /**
     * 
     * @type {WithSerialNumber}
     * @memberof UnicheckSimulatorDto
     */
    withSerialNumber?: WithSerialNumber;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    typeNumber?: string | null;
    /**
     * 
     * @type {Brand}
     * @memberof UnicheckSimulatorDto
     */
    brand1?: Brand;
    /**
     * 
     * @type {SingleDetectorConnectorType}
     * @memberof UnicheckSimulatorDto
     */
    singleDetectorConnectorType?: SingleDetectorConnectorType;
    /**
     * 
     * @type {DeviceInterfaceType}
     * @memberof UnicheckSimulatorDto
     */
    deviceInterfaceType?: DeviceInterfaceType;
    /**
     * 
     * @type {QaEquipmentSubCategory}
     * @memberof UnicheckSimulatorDto
     */
    subCategory: QaEquipmentSubCategory;
    /**
     * 
     * @type {CoordinateSystem}
     * @memberof UnicheckSimulatorDto
     */
    coordinateSystem?: CoordinateSystem;
    /**
     * 
     * @type {QaEquipmentStateOfUse}
     * @memberof UnicheckSimulatorDto
     */
    state?: QaEquipmentStateOfUse;
    /**
     * 
     * @type {boolean}
     * @memberof UnicheckSimulatorDto
     */
    isRegistrable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    serialNumber: string;
    /**
     * 
     * @type {PtwRegistrationState}
     * @memberof UnicheckSimulatorDto
     */
    registrationState?: PtwRegistrationState;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    registrationTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    deRegistrationTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    measurementDataChannelId?: string;
    /**
     * 
     * @type {IotDeviceStateOfUse}
     * @memberof UnicheckSimulatorDto
     */
    iotDeviceStateOfUse?: IotDeviceStateOfUse;
    /**
     * 
     * @type {boolean}
     * @memberof UnicheckSimulatorDto
     */
    hasValidLicense?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    licenseExpirationDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    calibrationCertificateNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    calibrationDate?: string | null;
    /**
     * 
     * @type {CalibrationDataDtoCalibrationState}
     * @memberof UnicheckSimulatorDto
     */
    calibrationState?: CalibrationDataDtoCalibrationState | null;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    $type?: UnicheckSimulatorDtoTypeEnum;
}


/**
 * @export
 */
export const UnicheckSimulatorDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDeviceComponentDtoUnicheckSimulatorDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.UnicheckSimulatorDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type UnicheckSimulatorDtoTypeEnum = typeof UnicheckSimulatorDtoTypeEnum[keyof typeof UnicheckSimulatorDtoTypeEnum];


/**
 * Check if a given object implements the UnicheckSimulatorDto interface.
 */
export function instanceOfUnicheckSimulatorDto(value?: unknown): value is UnicheckSimulatorDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(UnicheckSimulatorDtoTypeEnum)[0];
}

export function UnicheckSimulatorDtoFromJSON(json: any): UnicheckSimulatorDto {
    return UnicheckSimulatorDtoFromJSONTyped(json, false);
}

export function UnicheckSimulatorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnicheckSimulatorDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': !exists(json, 'creationTime') ? undefined : json['creationTime'],
        'creatorUserId': !exists(json, 'creatorUserId') ? undefined : json['creatorUserId'],
        'lastModificationTime': !exists(json, 'lastModificationTime') ? undefined : json['lastModificationTime'],
        'lastModifierUserId': !exists(json, 'lastModifierUserId') ? undefined : json['lastModifierUserId'],
        'commentCount': !exists(json, 'commentCount') ? undefined : json['commentCount'],
        'commentAttachmentsCount': !exists(json, 'commentAttachmentsCount') ? undefined : json['commentAttachmentsCount'],
        'lastComment': !exists(json, 'lastComment') ? undefined : json['lastComment'],
        'isAvailable': !exists(json, 'isAvailable') ? undefined : json['isAvailable'],
        'origin': !exists(json, 'origin') ? undefined : EntityOriginFromJSON(json['origin']),
        'possibleActions': !exists(json, 'possibleActions') ? undefined : (json['possibleActions'] === null ? null : (json['possibleActions'] as Array<any>).map(PossibleActionDtoFromJSON)),
        'creatorUser': !exists(json, 'creatorUser') ? undefined : UserCatalogDtoFromJSON(json['creatorUser']),
        'lastModifierUser': !exists(json, 'lastModifierUser') ? undefined : UserCatalogDtoFromJSON(json['lastModifierUser']),
        'editingUser': !exists(json, 'editingUser') ? undefined : UserCatalogDtoFromJSON(json['editingUser']),
        'editingTime': !exists(json, 'editingTime') ? undefined : json['editingTime'],
        'comments': !exists(json, 'comments') ? undefined : (json['comments'] === null ? null : (json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : (json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'isReferenced': !exists(json, 'isReferenced') ? undefined : json['isReferenced'],
        'isReferencedBy': !exists(json, 'isReferencedBy') ? undefined : (json['isReferencedBy'] === null ? null : (json['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoFromJSON)),
        'deleterUserId': !exists(json, 'deleterUserId') ? undefined : json['deleterUserId'],
        'deletionTime': !exists(json, 'deletionTime') ? undefined : json['deletionTime'],
        'isDeleted': !exists(json, 'isDeleted') ? undefined : json['isDeleted'],
        'name': json['name'],
        'iuid': !exists(json, 'iuid') ? undefined : json['iuid'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'typeSpecification': !exists(json, 'typeSpecification') ? undefined : json['typeSpecification'],
        'category': RtSystemCategoryFromJSON(json['category']),
        'manufacturer': RtSystemManufacturerFromJSON(json['manufacturer']),
        'model': json['model'],
        'subModel': !exists(json, 'subModel') ? undefined : json['subModel'],
        'imageId': !exists(json, 'imageId') ? undefined : json['imageId'],
        'isArchived': !exists(json, 'isArchived') ? undefined : json['isArchived'],
        'masterDeviceId': !exists(json, 'masterDeviceId') ? undefined : json['masterDeviceId'],
        'withSerialNumber': !exists(json, 'withSerialNumber') ? undefined : WithSerialNumberFromJSON(json['withSerialNumber']),
        'typeNumber': !exists(json, 'typeNumber') ? undefined : json['typeNumber'],
        'brand1': !exists(json, 'brand1') ? undefined : BrandFromJSON(json['brand1']),
        'singleDetectorConnectorType': !exists(json, 'singleDetectorConnectorType') ? undefined : SingleDetectorConnectorTypeFromJSON(json['singleDetectorConnectorType']),
        'deviceInterfaceType': !exists(json, 'deviceInterfaceType') ? undefined : DeviceInterfaceTypeFromJSON(json['deviceInterfaceType']),
        'subCategory': QaEquipmentSubCategoryFromJSON(json['subCategory']),
        'coordinateSystem': !exists(json, 'coordinateSystem') ? undefined : CoordinateSystemFromJSON(json['coordinateSystem']),
        'state': !exists(json, 'state') ? undefined : QaEquipmentStateOfUseFromJSON(json['state']),
        'isRegistrable': !exists(json, 'isRegistrable') ? undefined : json['isRegistrable'],
        'serialNumber': json['serialNumber'],
        'registrationState': !exists(json, 'registrationState') ? undefined : PtwRegistrationStateFromJSON(json['registrationState']),
        'registrationTime': !exists(json, 'registrationTime') ? undefined : json['registrationTime'],
        'deRegistrationTime': !exists(json, 'deRegistrationTime') ? undefined : json['deRegistrationTime'],
        'measurementDataChannelId': !exists(json, 'measurementDataChannelId') ? undefined : json['measurementDataChannelId'],
        'iotDeviceStateOfUse': !exists(json, 'iotDeviceStateOfUse') ? undefined : IotDeviceStateOfUseFromJSON(json['iotDeviceStateOfUse']),
        'hasValidLicense': !exists(json, 'hasValidLicense') ? undefined : json['hasValidLicense'],
        'licenseExpirationDate': !exists(json, 'licenseExpirationDate') ? undefined : json['licenseExpirationDate'],
        'calibrationCertificateNumber': !exists(json, 'calibrationCertificateNumber') ? undefined : json['calibrationCertificateNumber'],
        'calibrationDate': !exists(json, 'calibrationDate') ? undefined : json['calibrationDate'],
        'calibrationState': !exists(json, 'calibrationState') ? undefined : CalibrationDataDtoCalibrationStateFromJSON(json['calibrationState']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function UnicheckSimulatorDtoToJSON(value?: UnicheckSimulatorDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'lastModificationTime': value.lastModificationTime,
        'commentCount': value.commentCount,
        'commentAttachmentsCount': value.commentAttachmentsCount,
        'lastComment': value.lastComment,
        'isAvailable': value.isAvailable,
        'origin': EntityOriginToJSON(value.origin),
        'creatorUser': UserCatalogDtoToJSON(value.creatorUser),
        'lastModifierUser': UserCatalogDtoToJSON(value.lastModifierUser),
        'editingUser': UserCatalogDtoToJSON(value.editingUser),
        'editingTime': value.editingTime,
        'comments': value.comments === undefined ? undefined : (value.comments === null ? null : (value.comments as Array<any>).map(PtwCommentDtoToJSON)),
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : (value.attachments as Array<any>).map(FileMetaInfoDtoToJSON)),
        'isReferenced': value.isReferenced,
        'isReferencedBy': value.isReferencedBy === undefined ? undefined : (value.isReferencedBy === null ? null : (value.isReferencedBy as Array<any>).map(ReferencingObjectDtoToJSON)),
        'name': value.name,
        'iuid': value.iuid,
        'description': value.description,
        'typeSpecification': value.typeSpecification,
        'category': RtSystemCategoryToJSON(value.category),
        'manufacturer': RtSystemManufacturerToJSON(value.manufacturer),
        'model': value.model,
        'subModel': value.subModel,
        'imageId': value.imageId,
        'isArchived': value.isArchived,
        'masterDeviceId': value.masterDeviceId,
        'withSerialNumber': WithSerialNumberToJSON(value.withSerialNumber),
        'typeNumber': value.typeNumber,
        'brand1': BrandToJSON(value.brand1),
        'singleDetectorConnectorType': SingleDetectorConnectorTypeToJSON(value.singleDetectorConnectorType),
        'deviceInterfaceType': DeviceInterfaceTypeToJSON(value.deviceInterfaceType),
        'subCategory': QaEquipmentSubCategoryToJSON(value.subCategory),
        'coordinateSystem': CoordinateSystemToJSON(value.coordinateSystem),
        'state': QaEquipmentStateOfUseToJSON(value.state),
        'isRegistrable': value.isRegistrable,
        'serialNumber': value.serialNumber,
        'registrationState': PtwRegistrationStateToJSON(value.registrationState),
        'registrationTime': value.registrationTime,
        'deRegistrationTime': value.deRegistrationTime,
        'measurementDataChannelId': value.measurementDataChannelId,
        'iotDeviceStateOfUse': IotDeviceStateOfUseToJSON(value.iotDeviceStateOfUse),
        'hasValidLicense': value.hasValidLicense,
        'licenseExpirationDate': value.licenseExpirationDate,
        'calibrationCertificateNumber': value.calibrationCertificateNumber,
        'calibrationDate': value.calibrationDate,
        'calibrationState': CalibrationDataDtoCalibrationStateToJSON(value.calibrationState),
        '$type': value.$type,
    });
}

